import { InjectionToken, Type } from '@angular/core';

export const BATCH_REPAIR_PROGRESS_CARD = new InjectionToken<Type<unknown>>('BATCH_REPAIR_PROGRESS_CARD');
